import {Text} from '~/components';
import {Button} from '~/components/global/Button.client';
import {trackClickEvent} from '~/utils/trackClickEvent';

export function CartEmpty() {
  return (
    <div>
      <Text>
        Looks like you haven&rsquo;t added anything yet, let&rsquo;s get you
        started!
      </Text>
      <br />
      <br />
      <Button
        href="/collections"
        ctaText="Continue shopping"
        onClick={trackClickEvent('click_cta_continue_shopping')}
      />
    </div>
  );
}
